<template>
    <div class="about__section">
        <h3>{{ l('DEBUG_MODAL.PRINTING_HEADER') }}</h3>
        <dl>
            <dt>Print Preview</dt>
            <dd>
                <div class="btn-group-flex"
                     role="group">
                    <button type="button"
                            :class="{'active': !debugPrintIframes}"
                            class="btn btn-sm btn-default"
                            @click="setDebugPrintIframes(false)">
                        Hide
                    </button>
                    <button type="button"
                            :class="{'active': debugPrintIframes === 'show'}"
                            class="btn btn-sm btn-default"
                            @click="setDebugPrintIframes('show')">
                        Show
                    </button>
                    <button type="button"
                            :class="{'active': debugPrintIframes === 'interact'}"
                            class="btn btn-sm btn-default"
                            @click="setDebugPrintIframes('interact')">
                        Interact
                    </button>
                </div>
            </dd>

            <dt>Test Page</dt>
            <dd>
                <button class="btn btn-default btn-sm"
                        @click="printTestPage">
                    Print Test Page
                </button>
            </dd>
        </dl>
    </div>
</template>

<script>
import { container } from '@/container';

export default {
    name: 'DebugPrintingSection',

    data() {
        return {
            debugPrintIframes: null,
        };
    },

    methods: {
        updateDebugPrintIframesValue() {
            // Can't used a computed prop for these because it won't watch
            // the classList properly.
            if (document.body.classList.contains('interact-print-iframes')) {
                this.debugPrintIframes = 'interact';
                return;
            }

            if (document.body.classList.contains('show-print-iframes')) {
                this.debugPrintIframes = 'show';
                return;
            }

            this.debugPrintIframes = null;
        },

        setDebugPrintIframes(value) {
            document.body.classList.remove('show-print-iframes');
            document.body.classList.remove('interact-print-iframes');

            if (value === 'interact') {
                document.body.classList.add('interact-print-iframes');
                document.body.classList.add('show-print-iframes');
            } else if (value === 'show') {
                document.body.classList.add('show-print-iframes');
            }

            this.updateDebugPrintIframesValue();
        },

        printTestPage() {
            container.receiptPrinter
                .printTestPage(
                    {
                        appConfig: container.appConfig,
                    }
                )
                .then(() => {
                    console.log('Test page printed.');
                })
                .catch((e) => {
                    console.log('Printing test page failed.', e);
                });
        },
    },

};
</script>
